import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { appUrl } from "./pages/app_props";
import { hydrateAuth, ensureFreshSession } from "./pages/authStorage";
import { installFetchAuthGuard } from "./pages/apiGuard";
import "bootstrap/dist/css/bootstrap.min.css";

// Catch backend 401s app-wide and re-run the OAuth flow (see apiGuard.js).
installFetchAuthGuard();

// Drop an expired/dead token, then - unless we are at the app root or handling
// the OAuth callback - bounce through the OAuth `authorize` flow so the app is
// never rendered from a cached token belonging to a previously signed-in user.
hydrateAuth();
const redirecting = ensureFreshSession(appUrl);

if (!redirecting) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
      <React.StrictMode>
          <App />
      </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

